module.exports = "<div class=\"merge-attributions-modal\">\n  <div class=\"modal-header capitalize\">\n    <button type=\"button\" class=\"close\" ng-click=\"close()\">×</button>\n    <h4 class=\"modal-title\">\n      {{ modalHeader }}\n    </h4>\n  </div>\n  <div class=\"modal-body modal-no-padding\">\n    <merge-attributions attributions=\"attributions\" on-merged=\"onMerged\" cancel=\"close\"></merge-attributions>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modals/mergeAttributions/template.html
// module id = 1256
// module chunks = 0